import React from "react";
import { useSearchParams } from "react-router-dom";
import FeedbackForm from "./FeedbackForm";

const ProvideFeedbackPage = () => {
    const [searchParams] = useSearchParams();
    const toolName = searchParams.get("toolName") || "Unknown Tool"; // Default fallback

    return <FeedbackForm type="feedback" toolName={toolName} />;
};

export default ProvideFeedbackPage;
